import BaseController from './base_controller'

export default class extends BaseController {
  static classes = ['collapsed']

  toggle () {
    this.element.classList.toggle(this.collapsedClass)
  }
}
